import React from 'react';
import { Card, CardContent } from '../../../../components/ui/card';



export default function StepCard({ title, children }) {
  return (
    <Card className="rounded-2xl shadow-sm mb-6">
      <CardContent className="p-6">
        <h2 className="text-xl font-semibold mb-4">{title}</h2>
        {children}
      </CardContent>
    </Card>
  );
}
